import "./installGlobalErrorHandlers";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { RootErrorBoundary } from "./RootErrorBoundary";
import { registerServiceWorker } from "./registerServiceWorker";

registerServiceWorker();

const rootEl = document.getElementById("root");
if (!rootEl) {
  // eslint-disable-next-line no-console
  console.error("[ICJEME] No se encontró #root; el bundle no puede montar React.");
} else {
  if (document.body && !document.getElementById("icjeme-runtime-error-banner")) {
    const banner = document.createElement("div");
    banner.id = "icjeme-runtime-error-banner";
    banner.hidden = true;
    banner.style.cssText =
      "position:fixed;bottom:0;left:0;right:0;z-index:2147483646;padding:12px 16px;background:#7f1d1d;color:#fef2f2;font:14px/1.4 system-ui,sans-serif;white-space:pre-wrap;box-shadow:0 -4px 20px rgba(0,0,0,.2);";
    document.body.appendChild(banner);
  }

  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <RootErrorBoundary>
        <App />
      </RootErrorBoundary>
    </React.StrictMode>,
  );
}
